import {
  addPropertyApi,
  getPropertyByIdApi,
  queryPropertyListApi,
  updatePropertyApi,
  deletePropertyApi,
  addPropertyUnitApi,
  getPropertyUnitByIdApi,
  queryPropertyUnitListApi,
  updatePropertyUnitApi,
  deletePropertyUnitApi,
  queryPropertyFormTableListApi,
  commonApiApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加物业公司
  async addPropertyAction(context, param) {
    const res = await addPropertyApi(param)
    return res
  },
  //  根据id获取物业公司
  async getPropertyByIdAction(context, param) {
    const res = await getPropertyByIdApi(param)
    return res
  },
  //  查询物业公司列表
  async queryPropertyListAction(context, param) {
    const res = await queryPropertyListApi(param)
    return res
  },
  //  修改物业公司
  async updatePropertyAction(context, param) {
    const res = await updatePropertyApi(param)
    return res
  },
  //  删除物业公司
  async deletePropertyAction(context, param) {
    const res = await deletePropertyApi(param)
    return res
  },
  //  添加物业公司对应单元
  async addPropertyUnitAction(context, param) {
    const res = await addPropertyUnitApi(param)
    return res
  },
  //  根据id获取物业公司对应单元
  async getPropertyUnitByIdAction(context, param) {
    const res = await getPropertyUnitByIdApi(param)
    return res
  },
  //  查询物业公司对应单元列表
  async queryPropertyUnitListAction(context, param) {
    const res = await queryPropertyUnitListApi(param)
    return res
  },
  //  修改物业公司对应单元
  async updatePropertyUnitAction(context, param) {
    const res = await updatePropertyUnitApi(param)
    return res
  },
  //  删除物业公司对应单元
  async deletePropertyUnitAction(context, param) {
    const res = await deletePropertyUnitApi(param)
    return res
  },
  //  分页查询物业公司自定义表单信息
  async queryPropertyFormTableListAction(context, param) {
    const res = await queryPropertyFormTableListApi(param)
    return res
  },
  //  团队分销配置
  async commonApiAction(context, param) {
    const res = await commonApiApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
